<div class="main-header">
    <div class="branding">
      <div class="main-header__brand">
        <span class="main-header__logo" (click)="navigateToHome()" style="cursor: pointer;">{{ appName }}</span>
        <span class="main-header__divider">|</span>
        <img src="libs/Shared/assets/images/svg/Logo-black.png" alt="Swipesum Logo" class="main-header__partner">
      </div>
    </div>
    <div class="primary-navigation">
        <ng-content select="[primary-navigation]"></ng-content>
    </div>

    <!-- <div class="profile-dropdown">
      <button class="profile-btn" (click)="profileMenuOpen = !profileMenuOpen">
        profile
        <span class="material-symbols-outlined">arrow_drop_down</span>
      </button>
      @if (profileMenuOpen) {
      <div class="profile-dropdown__menu">
        <div class="profile-dropdown__email">{{user?.email}}</div>
        @if (isAdminUser || (isSetupComplete && !isClosedTrial())) {
        <button class="profile-dropdown__item" (click)="profileMenuOpen = false" routerLink="/manage/update-profile">
          profile & password
        </button>
        }
        <button class="profile-dropdown__item" (click)="auth.logout(); profileMenuOpen = false">
          sign out
        </button>
      </div>
      }
    </div> -->
</div>

